import { addNotification } from '../store';
import { baseApi } from './baseApi';

export interface SearchResultItem {
  id: number;
  type: string;
  name: string;
  updated_at: string;
  created_at: string;
  data: AssetFromApi & FolderFromApi & { [key: string]: any };
}

interface SearchApiResponse {
  data: SearchResultItem[];
  result: string;
}

export interface SearchQueryArgs {
  q: string;
  type?: string;
}

export const searchService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    search: builder.query<SearchApiResponse, SearchQueryArgs>({
      query: ({ q, type = 'files' }) => ({
        url: `/search`,
        params: { q, type },
      }),
      keepUnusedDataFor: 0,
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (result: any) {
          if (!result?.error) {
            return;
          }
          dispatch(addNotification({ type: 'error', message: 'Search failed. Please try again.' }));
        }
      },
    }),
  }),
});

export const { useSearchQuery } = searchService;
